import {
    DialogSize,
    RaikoBaseCardContainer, RaikoBaseDialogContentContainer, RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridThreeColumn, showErrorMessage,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {ReportBox, ReportBoxItemTypes} from "../../../raikoComponents/reportBox/ReportBox";
import React, {useEffect, useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {MawakibService} from "../../../serverService/mawakibService/MawakibService";
import {useParams} from "react-router-dom";
import {doDownloadFile} from "../../../util/DownloadHelper";
import {css} from "@emotion/css";

export default function MawakibDetailsReports({name}) {

    const {id: mawakibId = -1} = useParams()

    const service = new MawakibService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    function handleDownloadAllRegisters(_name = name, locationId = null, reportStatus) {
        loading.show()
        service.getMawakibCSVReports(mawakibId, locationId, reportStatus)
            .then(response => {
                doDownloadFile(response, `گزارش وضعیت ثبت نام ${_name}`, "xlsx")
            }).catch(reason => {
            if (reason.response.status === 404) {
                showErrorMessage("هیچ ثبت نام موکبی برای دریافت خروجی یافت نشد!")
            } else {
                showServerErrorMessage(reason)
            }

        }).finally(_ => {
            loading.hide()
        })
    }

    const [mawakibLocation, setMawakibLocation] = useState([]);

    useEffect(() => {
        loading.show()
        service.getMawakibLocationSelection(mawakibId)
            .then(response => {
                setMawakibLocation(response)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })

    }, []);


    const [openReportDialog, setOpenReportDialog] = useState(false)

    function handleCloseReportDialog() {
        setOpenReportDialog(false)
    }

    function handleOpenReportDialog() {
        setOpenReportDialog(true)
    }

    return (

        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseReportDialog}
                open={openReportDialog}
                pageTitle={"گزارش گیری"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <RaikoBaseDialogContentContainer>
                    <ReportBox
                        types={[ReportBoxItemTypes.XLSX]}
                        label={"گزارش تمام ثبت نام ها"}
                        handleOnClick={handleDownloadAllRegisters}
                    />
                    <ReportBox
                        types={[ReportBoxItemTypes.XLSX]}
                        label={"گزارش ثبت نام های پذیرفته شده"}
                        handleOnClick={_ => {
                            handleDownloadAllRegisters(mawakibId, null, "ACCEPTED")
                        }}
                    />
                    <ReportBox
                        types={[ReportBoxItemTypes.XLSX]}
                        label={"گزارش ثبت نام های رد شده"}
                        handleOnClick={_ => {
                            handleDownloadAllRegisters(mawakibId, null, "REJECTED")
                        }}
                    />
                    <ReportBox
                        types={[ReportBoxItemTypes.XLSX]}
                        label={"گزارش ثبت نام های در حال بررسی"}
                        handleOnClick={_ => {
                            handleDownloadAllRegisters(mawakibId, null, "AWAITING_FOR_REVIEW")
                        }}
                    />
                </RaikoBaseDialogContentContainer>
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn>
                <RaikoGridThreeColumn>
                    <RaikoBaseCardContainer>
                        <ReportBox
                            types={[ReportBoxItemTypes.XLSX]}
                            label={"گزارش تمام ثبت نام ها"}
                            handleOnClick={handleOpenReportDialog}
                        />
                    </RaikoBaseCardContainer>
                    {/*{*/}
                    {/*    mawakibLocation.map((location, index) => {*/}
                    {/*        return <RaikoBaseCardContainer key={index}>*/}
                    {/*            <ReportBox*/}
                    {/*                types={[ReportBoxItemTypes.XLSX]}*/}
                    {/*                label={`گزارش تمام ثبت نام ${location.title}`}*/}
                    {/*                handleOnClick={_ => {*/}
                    {/*                    handleDownloadAllRegisters(location.title, location.id)*/}
                    {/*                }}*/}
                    {/*            />*/}
                    {/*        </RaikoBaseCardContainer>*/}
                    {/*    })*/}
                    {/*}*/}
                </RaikoGridThreeColumn>
            </RaikoGridOneColumn>
        </>

    )
}